
import { apiRequest } from '../../apiCall'


export const getIVRSettings = (id) => apiRequest('IvrSettings.Get', {}, `?customerLineId=${id}`,true)
export const getSoundLink = (params) => apiRequest('Tts.GetAudioLink', { ...params })
export const saveIVRSettingRequest = (params) => apiRequest('IvrSettings.Save', { ...params },'',true)

export const getOnHoldMusics = () => apiRequest('MusicOnHold.GetAllMusicOnHold')
export const getS3UrlRequest = (link) => apiRequest('CustomerCall.GetURLLink', {}, `?url=${link}`,true)
export const uploadRequest = (file) => apiRequest('IvrFile.Upload', file)






